export interface ICurrentEnvironment {
  name: string
  baseUrl: string
  authUri: string
  galaxyUrl: string
  reportUrl: string
  googleUrl: string
  baseSalesApi: string
}

export class CurrentEnvironment implements ICurrentEnvironment {
  public name: string = ''
  public galaxyUrl: string = ''
  public reportUrl: string = ''
  public googleUrl: string = ''
  public baseUrl: string = ''
  public authUri: string = ''
  public baseSalesApi: string = ''

  constructor() {
    if (
      window.location.origin === 'http://localhost:8081' ||
      window.location.origin === 'https://onyx-joe.firebaseapp.com'
    ) {
      this.name = 'DEVELOPMENT'
      //this.baseUrl = 'https://api.staging.fastsigns.com'
      this.baseSalesApi = 'NONE'
      this.galaxyUrl = 'https://fs-galaxyreportapi-7puomjdo6q-uc.a.run.app/'
      this.reportUrl = 'https://fs-reportingapi-7puomjdo6q-uc.a.run.app/'
      this.baseUrl = 'https://fs-galaxyreportapi-7puomjdo6q-uc.a.run.app/'
      // this.authUri = "https://auth.fastsigns.com"
      // this.baseUrl = "https://api.staging.fastsigns.com";
      // //this.baseUrl = "http://localhost:5006";
      // this.authUri = "https://auth.staging.fastsigns.com";
      // this.baseSalesApi = "https://us-central1-fastsigns-dev.cloudfunctions.net/fs_sales_api";
    }

    if (
      window.location.origin === 'https://onyx.staging.fastsigns.com' ||
      window.location.origin === 'https://staging.onyx.fastsigns.com'
    ) {
      this.name = 'STAGING'
      this.baseUrl = 'https://api.staging.fastsigns.com'
      this.baseSalesApi = 'NONE'
      // this.authUri = "https://auth.fastsigns.com"
      // this.baseUrl = "https://api.staging.fastsigns.com";
      // this.authUri = "https://auth.staging.fastsigns.com";
      // this.baseSalesApi = "https://us-central1-fastsigns-dev.cloudfunctions.net/fs_sales_api";
    }

    if (
      window.location.origin === 'https://onyx.fastsigns.com' ||
      window.location.origin === 'https://fs-onyx.firebaseapp.com'
    ) {
      this.name = 'PRODUCTION'
      this.baseUrl = 'https://api.fastsigns.com'
      this.galaxyUrl = 'https://fs-galaxyreportapi-7puomjdo6q-uc.a.run.app'
      this.reportUrl = 'https://fs-reportingapi-7puomjdo6q-uc.a.run.app'
      this.googleUrl = 'https://fs-googleapi-7puomjdo6q-uc.a.run.app'
      this.baseSalesApi = 'NONE'
      // this.authUri = "https://auth.fastsigns.com"
    }
  }
}
